module.exports = __webpack_public_path__ + "static/media/om.a8ffbc41.svg";